import { errorApiRef, useApi } from '@backstage/core-plugin-api'
import useAsyncRetry from 'react-use/lib/useAsyncRetry'

import { circleCIApiRef, WorkflowJob } from '../api'

/**
 * Lazy job loader. The Builds page only fires this when a workflow row is
 * expanded, so we avoid the O(workflows) fan-out at list time.
 */
export function useWorkflowJobs(workflowId: string | null) {
  const api = useApi(circleCIApiRef)
  const errorApi = useApi(errorApiRef)

  const { loading, value, retry, error } = useAsyncRetry(async (): Promise<WorkflowJob[]> => {
    if (!workflowId) return []
    try {
      const resp = await api.getJobsForWorkflow(workflowId)
      // CircleCI returns jobs in declaration order; sort topologically by
      // dependency count so prerequisites surface above downstream jobs.
      return [...resp.items].sort(
        (a, b) => a.dependencies.length - b.dependencies.length || a.name.localeCompare(b.name)
      )
    } catch (e) {
      errorApi.post(e as Error)
      throw e
    }
  }, [workflowId, api, errorApi])

  return { loading, jobs: value ?? [], retry, error }
}
